import Vue from 'vue'
import Vuex from 'vuex'
import * as apiService from '@/services/apiService'
import { T_LANG, BASE_API_URL, BASE_API_URL_SHOPS, BASE_API_URL_SERVICES, BASE_API_URL_FOODS } from '@/config/AppConfig'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    orderBy: null,
    str: '',
    selectedCategories: [],
    categories: [],
    services: [],
    foods: [],
    items: []
  },
  getters: {
    getStoreVar: (state) => (key) => {
      return state[key]
    }
  },
  mutations: {
    setStoreVar: (state, {key, data}) => {
      state[key] = data
    }
  },
  actions: {
    setStoreVar (context, {key, data}) {
      context.commit('setStoreVar', {key, data})
    },

    getCategories (context, requestData) {
      return new Promise((resolve, reject) => {
        let lang = T_LANG
        apiService.makeApiCall(BASE_API_URL_SHOPS + lang, 'get')
          .then(response => {
            context.commit('setStoreVar', { key: 'categories', data: response })
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getServices (context, requestData) {
      return new Promise((resolve, reject) => {
        let lang = T_LANG
        apiService.makeApiCall(BASE_API_URL_SERVICES + lang, 'get')
          .then(response => {
            context.commit('setStoreVar', { key: 'services', data: response })
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getFoods (context, requestData) {
      return new Promise((resolve, reject) => {
        let lang = T_LANG
        apiService.makeApiCall(BASE_API_URL_FOODS + lang, 'get')
          .then(response => {
            context.commit('setStoreVar', { key: 'foods', data: response })
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getItems (context, requestData) {
      return new Promise((resolve, reject) => {
        let lang = T_LANG
        apiService.makeApiCall(BASE_API_URL + lang, 'get')
          .then(response => {
            context.commit('setStoreVar', {key: 'items', data: response})
            resolve('ok')
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js